import { PrismCard, PrismMessage } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import RegisterErrorCardHeaderTitle from 'frontend-login/components/register-error/card-header-title';

<template>
  <PrismCard data-test-email-already-sent>
    <:header as |Header|>
      <Header.title>
        <RegisterErrorCardHeaderTitle />
      </Header.title>
    </:header>
    <:content>
      <PrismMessage
        @description={{t "password.error.token_expired.email_already_sent"}}
        @illustration="100x100_tangled"
        @title={{t "general.error_title"}}
      />
    </:content>
  </PrismCard>
</template>
